import { RouteRecordRaw } from 'vue-router'

export const authRoutes: RouteRecordRaw[] = [
  {
    path: '/login',
    name: 'login',
    component: () =>
      import(
        /* webpackChunkName: "login" */
        '../views/LoginView.vue'
      ),
    meta: {
      plainLayout: true,
      onlyLoggedOut: true,
      title: 'Login'
    }
  },
  {
    path: '/login-especialistas',
    name: 'login-specialists',
    component: () =>
      import(
        /* webpackChunkName: "login-specialists" */
        '../views/LoginSpecialistsView.vue'
      ),
    meta: {
      plainLayout: true,
      onlyLoggedOut: true,
      title: 'Login Especialistas'
    }
  }
]
